import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

export default function PublicRoutes({ children }) {
  const { user } = useSelector((state) => state.login);
  const location = useLocation();

  const prevRoute = location.state ? location.state.referrer : undefined;
  
  if (user) {
    return <Navigate to={prevRoute ?? "subscription-management"} replace />;
  }

  return children;
}
